import { Component, HostBinding } from '@angular/core';
import { StoresDataService } from '../../services/stores.data.service';
import { StoreListQueryModel } from '../../model/models';
import { Router } from '@angular/router';
import {TableColumnDef} from 'app/shared/tables/table-column-def';

const NewCompShopUrl = 'metadata/stores/new-store';

@Component({
    selector: 'pr-app-shops-browser',
    templateUrl: './shops-browser.component.html',
})
export class ShopsBrowserComponent {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    navigateLinkArr: Array<string> = ['metadata', 'store'];

    columnsData: TableColumnDef[];
    tableId: string;
    sortBy = '';

    constructor(
        public storesService: StoresDataService,
        private router: Router
    ) {
        const tableInfo = StoreListQueryModel.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId;
    }

    public createNew(): void {
        this.router.navigateByUrl(NewCompShopUrl);
    }
}
